import {eventBus} from "../events/event-bus";

export function sendGenericErrorMessage() {
  eventBus.notification({
    type: "warning",
    header: "Hier scheint ein Fehler aufgetreten zu sein.",
    body: "Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut."
  });
  eventBus.fileUploadAborted();
}
